import { render, staticRenderFns } from "./form-praga.vue?vue&type=template&id=7bf1b8f4&"
import script from "./form-praga.vue?vue&type=script&lang=js&"
export * from "./form-praga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports